var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Cookies from 'js-cookie';
import apis from 'app/apis/index';
import store from 'app/configureStore';
import queryString from 'query-string';
export var getFirstName = function (object) {
    return object.firstName ||
        object.first_name ||
        object.given_name ||
        (object.user_metadata && object.user_metadata.first_name) ||
        null;
};
export var getLastName = function (object) {
    return object.lastName ||
        object.last_name ||
        object.family_name ||
        (object.user_metadata && object.user_metadata.last_name) ||
        null;
};
export var getCompany = function (object) {
    return object &&
        (object.company ||
            (object.user_metadata && object.user_metadata.company) ||
            null);
};
export var getUser = function (accessToken) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, error, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, apis.user.sandboxDbUser.get(accessToken)];
            case 1:
                _a = _b.sent(), error = _a[0], data = _a[1];
                if (data) {
                    return [2 /*return*/, data];
                }
                return [2 /*return*/, null];
        }
    });
}); };
var clone = function (obj) { return (__assign({}, obj)); };
export var renameKey = function (object, key, newKey) {
    var clonedObj = clone(object);
    var targetKey = clonedObj[key];
    delete clonedObj[key];
    clonedObj[newKey] = targetKey;
    return clonedObj;
};
export var getCookie = function (key) { return Cookies.get(key); };
export var setCookie = function (key, value, options) {
    if (!key || !value)
        return;
    Cookies.set(key, value, __assign(__assign({}, options), { secure: window.location.protocol === 'https:' }));
};
export var removeCookie = function (key) { return Cookies.remove(key); };
export var getUserFromStore = function () {
    var state = store.getState();
    return state.user;
};
export var checkIfProfileComplete = function (user) {
    return !!(getCompany(user) && getFirstName(user) && getLastName(user));
};
export var isEmailVerified = function () {
    var userProfile = getUserFromStore();
    // If userProfile does not exist means something was wrong with the getUser API call. Let the user proceed
    if (!userProfile)
        return true;
    // true is email is verified or if the connection is twitter (twitter connection does not have email_verified param)
    return (userProfile.email_verified ||
        (typeof userProfile.userId === 'string' &&
            userProfile.userId.indexOf('twitter|') > -1));
};
export var getSignupProgramName = function () {
    var query = queryString.parse(window.location.search);
    var programName = 'WBP Sandbox';
    if (query.programName ||
        query.program_name ||
        (window.localStorage && localStorage.getItem('neo_program_name'))) {
        programName =
            query.programName ||
                query.program_name ||
                (window.localStorage && localStorage.getItem('neo_program_name'));
    }
    return programName;
};
